import React, { useState, useEffect } from 'react';
import ContentVideo from '@components/content-video/ContentVideo';
import Actions from '../actions/Actions';
import { useStudentLessonContent } from '@src/hooks/useStudentLessonContent';

type Props = {
  data: string;
  isFullScreen: boolean;
  metaData?: {};
  onNext?: () => void;
  isPreview?: boolean;
  goBack?: () => void;
  startLesson?: () => void;
};

function Video(props: Props) {
  const { data, isFullScreen, metaData, onNext, isPreview, goBack, startLesson } = props;
  const {sllModule} = useStudentLessonContent();
  const [videoEnd, setVideoEnd] = useState(false);
  const [replay, setReplay] = useState(isPreview ? false : true);

  useEffect(() => {
    if (isPreview && replay) {
      setReplay(false);
    }
  }, [isPreview, replay]);

  const handleMoveNext = () => {
    if (onNext) {
      if (sllModule?.additionalAfter && !isPreview) {
        setVideoEnd(true);
        setReplay(false);
        return;
      }
      onNext();
    }
  }

  const handlePauseVideo = () => {
    setReplay(false);

  }

  const handleSetReplay = () => {
    setReplay(true);
  }

  return (
    <Actions fullScreen={isFullScreen} isPreview={isPreview} goBack={goBack} videoEnd={videoEnd} handlePauseVideo={handlePauseVideo}>
      <ContentVideo 
        data={data} metaData={metaData}
        isFullScreen={isFullScreen}
        autoPlay={!isPreview} 
        onNext={handleMoveNext} isProgram={true}
        replay={replay} 
        handleSetReplay={handleSetReplay}
        isPreview={isPreview}
        startLesson={startLesson}
        isNewLessonLayout={false}
      />
    </Actions>
  );
}

export default Video;
